module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    staticClass: "container",
    class: {
      'expand': _vm.checkout.currentStep == 1
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.checkout.currentStep == 0) ? [(_vm.itemsWithoutDiscounts) ? _c('cart-summary', {
    attrs: {
      "items": _vm.itemsWithoutDiscounts,
      "checkout": _vm.checkout
    },
    on: {
      "checkoutStep": function($event) {
        _vm.showNext()
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.checkout.currentStep == 1) ? [_c('order-summary', {
    attrs: {
      "checkout": _vm.checkout
    }
  }), _vm._v(" "), _c('checkout-info', {
    attrs: {
      "checkout": _vm.checkout
    }
  })] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "thank-you",
      "appear": "",
      "appear-active-class": "showThankyou"
    }
  }, [(_vm.checkout.currentStep == 2) ? _c('thank-you-section') : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-671c4558!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 82
// module chunks = 0